import { render, staticRenderFns } from "./icon-customer-light-user-tie-solid-eye.vue?vue&type=template&id=738cc29f&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports